module.exports = __webpack_public_path__ + "static/img/newanli-12.a3f2159e.png";